import {lazyLoadSlickIframes} from "../components/slick-iframe-lazy-load";
import "slick-slider";

jQuery(document).ready(($) => {


    $('#social_widget').get(0).addEventListener('sport1WidgetLoaded', function () {
        const $slider = $('#social_widget .social-posts-wrapper .posts');
        if (window.instgrm) {
            window.instgrm.Embeds.process();
        }

        lazyLoadSlickIframes($slider);

        $slider.slick({
            slideToShow: 1,
            slidesToScroll: 1,
            rtl: true,
            appendArrows: jQuery('#social_widget .social-posts-header'),
            prevArrow: '<span class="social-nav social-nav-prev">< הקודם</span>',
            nextArrow: '<span class="social-nav social-nav-next">הבא ></span>',
            infinite: false,
            adaptiveHeight: false
        });



        $('.reaction').on('click', (e) => {
            e.stopPropagation();
            jQuery('#social_widget .social-posts-wrapper .posts').slick('slickNext')
        });


        $slider.on('afterChange', function (event, slick, currentSlide) {
            $('#social_widget .post-number').text(`#${currentSlide + 1}`);
        });


    });

});